import React from "react";
// import PropTypes from "prop-types";
import { Helmet } from 'react-helmet';

import { Header } from "../header/Header";
import { Footer } from "../footer/Footer";

import classNames from "classnames/bind";
import styles from "./Layout.module.scss";

class Template extends React.Component {
    render() {
        const {
            children,
            className,
            isHome,
            title,
            type
        } = this.props;

        const links = [
            {
                name: "Home",
                url: "/"
            },
            {
                name: "Posts",
                url: "/posts/1"
            },
            {
                name: "Reviews",
                url: "/reviews/1"
            },
            {
                name: "Podcasts",
                url: "/podcasts/1"
            },
            {
                name: "About",
                url: "/about/"
            }
        ];

        const cx = classNames.bind(styles);

        const classes = cx(
            "wrapper",
            className,
            type
        );

        return (
            <div className={classes}>
                <Helmet>
                    <title>{title ? title : "OZARIN"}</title>
                </Helmet>

                <Header
                    isHome={isHome}
                    links={links}
                    type={type}
                />

                <div>
                    {children}
                </div>

                <Footer 
                    className={styles.footer}
                />
            </div>
        )
    }
};


// Template.propTypes = {
    
// };

// Template.defaultProps = {
    
// };

export default Template;